









































































import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { updateAdmin, AdminCommonReq } from "@/api/admin";
import { ResCode, Admin } from "@/api/baseDefine";
import { getQiniuToken, QiniuTokenRes } from "../../api/admin";
import * as uuid from "uuid";
@Component
export default class AdminUserInfo extends Vue {
  private uploadQiniuUrl: string = "https://up-z2.qiniup.com"; // 七牛云服务器地址
  private imageUrl: string = "";
  private admin: Admin = <Admin>{
    userName: "",
    phone: "",
    email: "",
    companyName: "",
    position: "",
    frontRole: "",
    portrait: "",
  };

  private getAdminUserInfo() {
    this.admin.id = UserModule.id;
    this.admin.userName = UserModule.name;
    this.admin.phone = UserModule.phone;
    this.admin.email = UserModule.email;
    this.admin.companyName = UserModule.companyName;
    this.admin.position = UserModule.position;
    this.admin.frontRole = UserModule.frontRole;
    this.admin.portrait = UserModule.portrait;
    this.imageUrl = this.admin.portrait;
  }

  public async update() {
    const res = await updateAdmin(<AdminCommonReq>{ admin: this.admin });
    if (res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.updateUserInfoSuccess").toString(),
        type: "success",
      });
      await UserModule.GetInfo();
      this.$router.push("/dashboard");
    }
  }
  private qiniuData = {
    key: "", // 图片名字处理
    token: "", // 七牛云token
    domain: "",
  };
  private beforeUploadGetKey() {
    this.qiniuData.key = "meter/admin/portrait/" + uuid.v1();
  }
  private successUploadGetKey(response, file, fileList) {
    this.imageUrl = this.qiniuData.domain + "/" + this.qiniuData.key;
    this.$notify({
      title: this.$t("common.success").toString(),
      message: this.$t("notification.UploadSuccess").toString(),
      type: "success",
      duration: 2000,
    });
    this.admin.portrait = this.imageUrl;
  }
  private handleChange(file, fileList) {
    // @ts-ignore
    this.$refs.upload.submit();
  }

  public async qiniuToken() {
    const res = await getQiniuToken();
    if (res && res.code === ResCode.SUCCESS) {
      this.qiniuData.token = res.data.token;
      this.qiniuData.domain = res.data.domain;
    }
  }

  private created() {
    this.getAdminUserInfo();
    this.qiniuToken();
  }
}
